<template>
  <el-dialog class="nf360-modal" v-bind="$attrs" destroy-on-close>
    <template #header>
      <slot name="header" />
    </template>
    <div class="nf360-content-modal">
      <slot name="content" />
    </div>
    <template #footer>
      <div class="nf360-modal-footer">
        <slot name="footer" />
      </div>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup></script>
<style lang="scss">
.nf360-modal {
  padding: 0;

  header {
    border-bottom: 1px solid #dee2e6;
    padding: 5px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: auto;
    height: 35px;

    .financas-dialog__close {
      margin-bottom: 16px;
    }
  }

  .financas-dialog__body {
    padding: 5px 10px;
  }

  .nf360-content-modal {
    overflow-y: auto;
    position: relative;
    padding: 1rem;

    form {
      label.financas-form-item__label {
        margin-bottom: 3px !important;
      }
    }
  }
  footer {
    border-top: 1px solid #ebebeb;
    padding: 16px 16px 10px;
    text-align: right;
  }

  .financas-button--small {
    height: 32px;
    border-radius: 4px;
  }
}
</style>
